const STOPPED = '__propagationStopped';

const stopPropagation = function (e) {
  const original = e.stopPropagation;
  e[STOPPED] = true;
  e.stopPropagation = function () {
    e[STOPPED] = true;
    return original.call(this);
  };
}

const isPropagationStopped = function (e) {
  return e[STOPPED] === true;
}

export { stopPropagation, isPropagationStopped }